import FontFaceObserver from 'fontfaceobserver';

export const fontFamilies = ['Poppins', 'Inter'];

/**
 * @param {string} fontFamily
 */
async function waitUntilFontLoads(fontFamily) {
	/* Font face observer will always throw an error when observing local fonts
  (e.g. Arial), which is a false-positive. That's why `document.fonts.check` is
  necessary. */
	const didFontAlreadyLoad = document.fonts.check(`16px ${fontFamily}`);
	if (didFontAlreadyLoad) return;

	const maxWaitTime = 60 * 1000; // 60 seconds
	const fontLoadPromise = new FontFaceObserver(fontFamily).load(null, maxWaitTime);

	await fontLoadPromise;
}

export async function waitUntilAllSupportedFontsLoad() {
	const fontLoadPromises = fontFamilies.map((fontFamily) => {
		return waitUntilFontLoads(fontFamily);
	});
	const fontsLoadPromise = Promise.allSettled(fontLoadPromises);

	return await fontsLoadPromise;
}
